// Batch 35 · fork V — B35-8 (vouching sheet columns: the (i) note on "Amount per support document"). EN + AR.
export const I18N_B35V = {
  en: {
    b35v: {
      aboutColumn: "About this column",
    },
  },
  ar: {
    b35v: {
      aboutColumn: "حول هذا العمود",
    },
  },
};
export default I18N_B35V;
